// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"603":"edit_prose","2964":"editing-edit-prose","3616":"edit_editorjs","6886":"editing-edit-tinymce","9973":"styles-tinymce_custom_style-css"}[chunkId] || chunkId) + ".css";
};